import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { gridFormatters, gridValueGetters } from 'src/utils/grid'
import { TableTags } from 'src/components/tags/TableTags'
import React from 'react'
import { MCOnboarding } from 'src/interfaces/mcOnboarding'
import { MCStatus } from '../mc/enums'
import { OnboardingStatusChip } from 'src/components/onboarding/shared/OnboardingStatusChip'
import { OnboardingStatus } from '../onboarding/enums'
import { MCStatusChip } from 'src/components/mc-list/shared/MCStatusChip'

const sharedOnboardingsColumns: Array<GridColDef> = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    minWidth: 120,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<MCOnboarding>) => {
      return params.row.inviteId || params.row.masterContractorExternalId
    },
  },
  {
    field: 'companyName',
    headerName: 'Company name',
    flex: 2,
    minWidth: 140,
    sortable: false,
  },
]

const emailColumns: Array<GridColDef> = [
  {
    field: 'ownerEmail',
    headerName: 'Email',
    flex: 3,
    minWidth: 140,
    sortable: false,
  },
]

const tagsColumns: Array<GridColDef> = [
  {
    field: 'tags',
    headerName: 'Tag(s)',
    flex: 2,
    minWidth: 120,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<MCOnboarding>) => params.row?.tags.join(', '),
    renderCell: (params: GridRenderCellParams<MCOnboarding>) =>
      params.row?.tags.length ? <TableTags tags={params.row?.tags || []} /> : <span>-</span>,
  },
]

const invitedContractorsTable: Array<GridColDef> = [
  ...sharedOnboardingsColumns,
  {
    field: 'status',
    headerName: 'Status',
    flex: 2,
    minWidth: 160,
    sortable: false,
    renderCell: (params: GridRenderCellParams<MCOnboarding>) => {
      return <MCStatusChip status={params.row.isSignedUp ? 'pending' : MCStatus.Invited} />
    },
  },
  ...emailColumns,
  {
    field: 'invitedAt',
    headerName: 'Invited at',
    flex: 2,
    minWidth: 140,
    sortable: false,
    type: 'date',
    valueGetter: gridValueGetters.parseDateUTC,
    valueFormatter: gridFormatters.formatShortDate,
  },
  ...tagsColumns,
]

export const mcOnboardingColumns: Record<MCStatus, Array<GridColDef>> = {
  [MCStatus.Activated]: [],
  [MCStatus.Deactivated]: [],
  [MCStatus.Invited]: invitedContractorsTable,
  [MCStatus.Rejected]: [
    ...sharedOnboardingsColumns,
    ...emailColumns,
    {
      field: 'status',
      headerName: 'Status',
      flex: 2,
      minWidth: 160,
      sortable: false,
      renderCell: () => {
        return <OnboardingStatusChip onboardingStatus={OnboardingStatus.Failed} />
      },
    },
    {
      field: 'rejectedAt',
      headerName: 'Failed at',
      flex: 2,
      sortable: false,
      type: 'date',
      valueGetter: gridValueGetters.parseDate,
      valueFormatter: gridFormatters.formatShortDate,
    },
    ...tagsColumns,
  ],
}

export const mcOnboardingInitialSortFields = {
  [MCStatus.Invited]: 'invitedAt',
  [MCStatus.Rejected]: undefined,
  [MCStatus.Activated]: undefined,
  [MCStatus.Deactivated]: undefined,
}

export const mcOnboardingPageSizeOptions = [100, 250, 500, 1000]
